const modalInviteLinkId = 'msync-member-invite-link'
const modalPendingInviteTblBtnId = {
  setAsManager: {
    action: 'invitation_set_as_manager',
    title: 'Set as Manager',
    request: 'msync_pending_invite_set_as_manager',
    content: "Set this user from member to manager user will have the management permissions. Managers can add and remove users. Confirm your choice to proceed."
  },
  setAsMember: {
    action: 'invitation_set_as_member',
    title:  'Set as Member',
    request: 'msync_pending_invite_set_as_member',
    content: 'Set this user from manager to member user will remove their management capabilities. They will no longer be able to invite or remove other users.  Confirm your choice to proceed.'  
  },
  resendInvitation: {
    action: 'invitation_resend',
    title: 'Resend',
    request: 'msync_pending_invite_resend',
    content: 'Are you sure you want to resend the invitation to this user? They will be notified again. Confirm your choice to proceed.'
  },
  revokeInvitation: {
    action: 'invitation_revoke',
    title: 'Revoke',
    request: 'msync_pending_invite_revoke',
    content: 'Are you sure you want to cancel the invitation sent to this user? This action cannot be undone and the user will not be automatically notified of the cancellation. Confirm your choice to proceed.'
  }
}

const copyToClipboard = ( text ) => {
  let dummy = document.createElement("textarea")
  document.body.appendChild(dummy)
  dummy.value = text
  dummy.select()
  const result = document.execCommand("copy") ? true : false
  document.body.removeChild(dummy)
  return result
}

export{
  modalInviteLinkId,
  modalPendingInviteTblBtnId,
  copyToClipboard
}
